<template>
    <div class="equipment-container" id="equipmentLedger">
        <div class="equipment-search">
            <Search :deviceClassify="deviceClassify"
                :deviceTypeOptions="deviceType"
                :count="count"
                @deviceClassifyChanged="changeClassify"
                @filter="changeType"
                @query="queryName"></Search>
        </div>
        <div class="equipment-table">
            <Table :data="filterData"
                :deviceClassify="classify" 
                @showDetail="showDetail"></Table>
        </div>
        <Details v-if="isShowDetail"
            :classify="classify"
            :dialogVisible="isShowDetail"
            :checkedDevicesDetails="checkedDevicesDetails"
            :checkedDevicesInfo="checkedDevicesInfo"
            :isOnline="isOnline"
            :loopInfomation="loopValue" 
            :detailStatus="detailStatus"
            @closeDetail="closeDetail"
        ></Details>
    </div>
</template>

<script>
import Search from '../../components/EquipmentLedger/equipment/Search';
import Table from '../../components/EquipmentLedger/equipment/Table';
import Details from '../../components/EquipmentLedger/equipment/Details';

import { GetDevicesTree, GetLoopForDevice, GetDeviceTypes, GetDeviceForName } from '../../api/equipment';

export default {
    data () {
        return {
            // 是否显示详情对话框
            isShowDetail: false,
            // 选择要查看的设备Id
            checkedDevicesId: '',
            // 要查看的设备的简介
            checkedDevicesInfo: '',
            // 要查看的设备的详情
            checkedDevicesDetails: '',
            // 查看的设备种类
            classify: '变配电设备',
            // 查看的设备类型
            type: '',
            // 查询的设备名称
            name: '',
            // axios请求数据
            data: [],
            // 设备类别
            // deviceClassify: ['变配电设备', '网关设备',"光伏设备","储能设备"],
            deviceClassify: ['变配电设备'],
            // 设备类型
            deviceType: [],
            // 分类的设备数据
            deviceMap: {变配电设备: [], 网关设备: [],光伏设备:[],储能设备:[]},
            // 设备关联的回路信息
            loopValue: [],
            // 详情页状态status: loading | loaded | error
            detailStatus: 'loaded',
            // 按名称查询前缓存数据
            temp: '',
            // 在线的Ebox
            isOnline: true,
        }
    },
    components: {
        Search,
        Table,
        Details
    },
    methods: {
        // 显示对话框
        showDetail: async function (row, isOnline) {
            // console.log(row);
            this.detailStatus = 'loading';
            this.isShowDetail = true;
            this.isOnline = isOnline;
            this.checkedDevicesId = row.id;
            this.checkedDevicesDetails = row.details;
            this.checkedDevicesInfo = row;
            this.loopValue = await this.getloop(row.id);
            this.detailStatus = 'loaded';
        },
        // 关闭对话框
        closeDetail() {
            this.isShowDetail = false;
        },
        // 改变查看的设备种类(配电-网关-断路器)
        changeClassify(deviceClassify) {
            this.classify = deviceClassify;
        },
        // 改变查看设备的类型(变压器-电表)
        changeType(deviceType) {
            this.type = deviceType;
        },
        // 查询的名字
        async queryName(deviceName) {
            this.name = deviceName;
        },
        // 判断状态码 取出data
        transformForData(response) {
            const {code, data, status} = response.data;
            if (code !== 200 && status !== true) {
                console.error('response error: code is not 200 or status is not true');
                return null;
            }
            
            return data;
        },
        dataMapper(data) {
            if (data.length === 0) {
                return [];
            }
            return data.map(item => {
                return {
                    id: item.device_id,
                    img: item.device_img,
                    deviceName: item.device_name, 
                    type: item.device_type_name, 
                    modelNumber: item.device_model_name, 
                    siteName: item.area_name,
                    details: item.device_details,
                    deviceTypeId: item.device_type_id,
                    mac: item.mac,
                    svg: item.device_svg,
                }
            })
        },
        // 获取设备回路树形结构
        async getloop(deviceId) {
            let loops = await GetLoopForDevice(deviceId);
            loops = this.transformForData(loops);
            if (!loops.devices) {
                this.detailStatus = 'error';
                return;
            }
            let array = [];
            // console.log(loops.devices);
            loops.devices.forEach(element => {
                if (element.loopType === 'IN') {
                    array.push({type: '进线', loopName: element.loopName, breakerName: '断路器名称', children: []});
                } else if (element.loopType === 'OUT') {
                    array.length !== 0 ?
                    array[0].children.push({type: '出线', loopName: element.loopName, breakerName: '断路器名称'})
                    : 
                    array.push({type: '出线', loopName: element.loopName, breakerName: '断路器名称', children: []});
                }
            });
            return array;
        },
        // 获取指定类型的设备
        async getDeviceForName(projectId, name) {
            let result = await GetDeviceForName(projectId, name);
            result = this.transformForData(result);
            //console.log(result, this.classify);
            result.devices = result.devices.filter(item => item.name === this.classify);
            //console.log(result.devices);
            return this.dataMapper(result.devices);
        }
    },
    async mounted() {
        //获取设备树和设备类型
        let response = await Promise.all([GetDevicesTree(this.projectId), GetDeviceTypes()]);

        // console.log(response);
        let result = this.transformForData(response[0]);
        let types = this.transformForData(response[1]);
        // console.log(result, types);
        // 根据不同设备类型对数据分组
        result.devices.forEach(item => {
            if (item.name === '变配电设备') {
                this.deviceMap.变配电设备.push(item);
            } else if (item.name === '网关设备') {
                let mac = ''; 
                try {
                    mac = JSON.parse(item.device_details).设备地址.code;
                } catch (error) {
                    console.error('json parse fail');
                }
                item.mac = mac;
                this.deviceMap.网关设备.push(item);
            }else if (item.name === '光伏设备') {
                this.deviceMap.光伏设备.push(item);
            }else if (item.name === '储能设备') {
                this.deviceMap.储能设备.push(item);
            }
        });
        // console.log(this.deviceMap)
        // 遍历获取所有的设备类型
        types = types.all.map(item => {
            return {label: item.deviceTypeName, value: item.deviceTypeId};
        });
        // 添加一项为全部设备类型
        types.unshift({value: '', label: '全部'});
        this.deviceType = types;
        this.data = this.dataMapper(this.deviceMap.变配电设备);
    },
    computed: {
        // 获取项目id
        projectId: function() {
            return this.$store.getters.projectId;
        },
        // 获取设备数目
        count: function () {
            return this.filterData.length;
        },
        // 根据过滤条件筛选出符合的设备
        filterData: function () {
            return this.dataMapper(
                    this.deviceMap[this.classify]
                        .filter(item => {
                            if (!this.type) {
                                return true;
                            } else {
                                return item.device_type_id === this.type
                            }
                        })
                        .filter(item => item.device_name.includes(this.name))
                    );
        }
    },
    watch: {
        // 切换种类将筛选条件清空
        classify: function (val, oldval) {
            this.type = '';
            this.name = '';
        }
    }
}
</script>

<style lang="less" scoped>
.equipment-container {
    display: flex;
    flex-direction: column;
    height: 100%;

    .equipment-search {
        .h(96);
    }

    .equipment-table {
        flex: 1;
        overflow:hidden;
        //火狐隐藏滚动条
        scrollbar-width: none;

        ::-webkit-scrollbar {
            display: none;
        }
    }
}
</style>